import type { Color } from "@mui/material";
import { blue, blueGrey, cyan, deepPurple, grey } from "@mui/material/colors";
import type { CompanyType } from "../api/clientTypes";
import { makeModeAwareAccent } from "../utilities/colorHelper";
import StatusChip from "./StatusChip";

interface Props {
  type: CompanyType;
}

type NonProductionCompanyType = Exclude<CompanyType, "Production">;

const badgeColors: Record<NonProductionCompanyType, Color> = {
  Training: deepPurple,
  Demo: blue,
  Template: blueGrey,
  Sandbox: cyan,
};

const labels: Record<NonProductionCompanyType, string> = {
  Training: "Training",
  Demo: "Demo",
  Template: "Template",
  Sandbox: "Sandbox",
};

const CompanyTypeBadge = ({ type }: Props) => {
  if (type === "Production") {
    return null;
  }

  const badgeColor = badgeColors[type] || grey;
  const label = labels[type] || type;
  return <StatusChip label={label} color={(t) => makeModeAwareAccent(t, badgeColor)} />;
};

export default CompanyTypeBadge;
